<div class="card">
	<p-dataView #dv
		layout="grid"
		[value]="evidences"
		[paginator]="false"
		[rows]="12"
		filterBy="name"
		[sortField]="sortField"
		[sortOrder]="sortOrder"
		>
		<ng-template pTemplate="header">

			<div class="p-d-flex p-flex-column p-flex-md-row p-jc-md-between">
				<div class="flex align-items-center justify-content-center h-4rem font-bold m-2">
					<div class="field">
						<label for="dateformat">DateFormat</label>
						<p-calendar [(ngModel)]="filterDate" (onSelect)="changeEvidences($event)" [maxDate]="maxDate" [showIcon]="true" dateFormat="yy-mm-dd" inputId="dateformat"></p-calendar>
					</div>
				</div>
			</div>
		</ng-template>
		<ng-template let-evidence pTemplate="gridItem">
			<div class="p-col-12 p-med-2 p-lg-2">
				<div class="product-grid-item card">
					<div class="product-grid-item-content">
						<p-image [preview]="true"class="grid-image" src="{{evidence.url}}"></p-image>
						<div class="product-name" >{{(getDataByUrl(evidence)) | date:'d MMMM y, h:mm:ss a'}}</div>
					</div>
				</div>
			</div>
		</ng-template>
	</p-dataView>

</div>
